import { t } from 'i18next';

export const translateCategory = (category: string, language: string) => {
  return language === 'ru' ? category : t(`categories.${category}`);
};
